<template>
  <div>
    <iModal
      title="人员信息"
      v-model="flag"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="姓名：" prop="name">
              <Input type="text" v-model="formInline.name" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="职务：" prop="JobTitle">
              <Input type="text" v-model="formInline.JobTitle" placeholder="请输入职务" />
            </FormItem>
            <FormItem label="手机：" prop="mobile">
              <Input type="text" v-model="formInline.mobile" placeholder="请输入手机" disabled />
            </FormItem>
            <!-- <FormItem label="验证码：" class="form-code-item" prop="captcha">
              <Input type="text" v-model="formInline.captcha" placeholder="请输入验证码" />
              <Button type="text" v-if="showCode" @click="getCaptcha" class="form-code-btn">获取验证码</Button>
              <Button type="text" v-else disabled class="form-code-btn">{{count}}s后重新获取</Button>
            </FormItem> -->
            <FormItem>
              <Checkbox size="large" v-model="formInline.isShow">
                <span style="display: inline-block;width: 10px;"></span>开启显示
              </Checkbox>
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :min="0" v-model="formInline.showindex"></InputNumber>
              <br><span style="font-size:12px;">(数字越小在您的人员显示列表中显示越靠前)</span>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  // 修改管理员信息modal
  name: "editAdmin",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editOperateInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      flag: true,
      loading: false,
      showModal: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        // form双向绑定
        name: "", // 姓名
        JobTitle: "", // 职务
        isShow: true, // 是否显示
        showindex: 0, // 显示顺序
      },
      ruleInline: {
        // 效验规则
        name: [
          {
            required: true,
            message: "用户为必填选项",
            trigger: "blur"
          }
        ],
        JobTitle: [
          {
            required: true,
            message: "职务为必填选项",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  },
  methods: {
    ...mapActions({
      editStaff: "companyModule/editStaff",
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Id: this.editOperateInfo.staffId,
        SetValues: {
          Name: form.name,
          JobTitle: form.JobTitle,
          IsShow: form.isShow,
          ShowIndex: form.showindex
        }
      }
      console.log('req',req);
      let bool = await this.editStaff(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("编辑失败，请重新尝试");
      } else if (!bool.successed) {
        this.loading = false;
        this.$Message.error("编辑失败，请重新尝试");
      } else {
        this.$emit('finish');
        this.$Message.success("编辑成功！");
        this.cancel();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$emit("close");
      this.init();
    },
    async init() {
      if (this.editOperateInfo) {
        this.formInline.name = this.editOperateInfo.name;
        this.formInline.JobTitle = this.editOperateInfo.jobTitle;
        this.formInline.mobile = this.editOperateInfo.phoneNumber;
        this.formInline.isShow = this.editOperateInfo.isShow;
        this.formInline.showindex = this.editOperateInfo.showIndex;
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

